<div
  class="destination-settings-form"
  [class.destination-settings-form--readonly]="readonly"
  [class.destination-settings-form--clipping-sidebar]="appearance === 'clipping-sidebar'"
>
  <div class="ts-form-group content-control-dropdown destination-settings-form__dropdown-row">
    <div class="ts-action">
      <span class="label">Default privacy</span>
      <icn-dropdown
        [large]="true"
        [allowMultiple]="false"
        [listDown]="true"
        [disabled]="readonly"
        [selectedValue]="selectedPrivacy"
        (selectedValueChange)="onPrivacyChange($event)"
      >
        <icn-dropdown-item
          *ngFor="let option of privacyOptions"
          [value]="option"
          [title]="option"
        ></icn-dropdown-item>
      </icn-dropdown>
    </div>

    <div class="ts-action">
      <span class="label">Video category</span>
      <icn-dropdown
        [large]="true"
        [allowMultiple]="false"
        [listDown]="true"
        [disabled]="readonly"
        [selectedValue]="selectedCategoryId"
        (selectedValueChange)="onCategoryChange($event)"
      >
        <icn-dropdown-item
          *ngFor="let item of catalog.items"
          [value]="item.id"
          [title]="item.title"
        ></icn-dropdown-item>
      </icn-dropdown>
    </div>
  </div>

  <p *ngIf="showQuotaNotice" class="destination-settings-form__quota-note">
    Default category list (YouTube API quota exceeded). Regional categories may differ.
  </p>

  <div class="ts-form-group destination-settings-form__checkbox-row">
    <div class="ts-action">
      <mat-checkbox
        [disabled]="readonly"
        [checked]="madeForKids"
        (change)="onMadeForKidsChange($event.checked)"
      ></mat-checkbox>
      <span class="label">Made for kids</span>
    </div>

    <div class="ts-action">
      <mat-checkbox
        [disabled]="readonly"
        [checked]="notifySubscribers"
        (change)="onNotifySubscribersChange($event.checked)"
      ></mat-checkbox>
      <span class="label">Notify subscribers</span>
    </div>
  </div>
</div>
